import 'moment/locale/de'
import SnowfallComponent from '../../components/snowfallComponent/SnowfallComponent'
import AttributeComponent from '../../components/webViewComponents/attributeComponent/AttributeComponent'
import DocumentComponent from '../../components/webViewComponents/documentComponent/DocumentComponent'
import Footer from '../../components/webViewComponents/footer/Footer'
import General from '../../components/webViewComponents/general/General'
import InfoHeader from '../../components/webViewComponents/infoHeader/InfoHeader'
import ManufacturerIconComp from '../../components/webViewComponents/manufacturerIconComp/ManufacturerIconComp'
import QrCodeComponent from '../../components/webViewComponents/qrCodeComponent/QrCodeComponent'
import { IComponent } from '../../models/IComponent'
import { Utils } from '../../utils/Utils'
import './WebView.scss'
import { ComponentType } from '../../models/componentType.enum'
import { useEffect } from 'react'

interface WebViewProps {
    isSeasonEffect: boolean
    component: IComponent
    isEditorView?: boolean
    componentQrCode?: string
    selectedLanguage?: string
    setSelectedLanguage?: (language: string) => void
}

function WebView({
    isSeasonEffect,
    component,
    isEditorView = false,
    componentQrCode,
    selectedLanguage,
    setSelectedLanguage }: WebViewProps) {
    let backgroundColor = Utils.getBackgroundColor(component.type)
    if (component.manufacturerColor) {
        backgroundColor = component.manufacturerColor
    }
    const manufacturerIcon = { iconFile: new File([], ''), iconUrl: component?.manufacturerIcon ? decodeURIComponent(component.manufacturerIcon) : '' }
    const productIcon = { iconFile: new File([], ''), iconUrl: component?.productIcon ? decodeURIComponent(component.productIcon) : '' }
    document.title = component.productName
    const { type } = Utils.getDefaultParameters()

    useEffect(() => {
        if (type === ComponentType.GEMUE_EXTERNAL || component?.type === ComponentType.GEMUE_EXTERNAL) {
            document.documentElement.style.setProperty('--primaryColor', '#D80000');
            document.documentElement.style.setProperty('--secondaryColor', '#724592');
            document.documentElement.style.setProperty('--textFontFamily', 'GEMUSans, sans-serif');
            document.documentElement.style.setProperty('--textFontFamilyEditor', 'GEMUSans, sans-serif');
            document.documentElement.style.setProperty('--titleFontFamily', 'GEMUSans Bold, sans-serif');
        }
    }, [type]);
    return (
        <div className={type === ComponentType.GEMUE_EXTERNAL ? "gemue_wv_wrapper_1 wv_wrapper_1" : "wv_wrapper_1"} data-testid='web_view'>
            {isSeasonEffect && <SnowfallComponent />}
            <div className='wv_wrapper_2' style={{ backgroundColor }}>
                <div className='container_wrapper'>
                    <ManufacturerIconComp
                        manufacturerUrl={component.manufacturerUrl}
                        manufacturerIcon={manufacturerIcon}
                        type={component.type}
                        isEditorView={isEditorView}
                        selectedLanguage={selectedLanguage}
                        setSelectedLanguage={setSelectedLanguage} />
                    <InfoHeader
                        productName={component.productName}
                        productIcon={productIcon}
                        isEditorView={isEditorView}
                        type={component.type}
                    />
                    <div className='info_wrapper'>
                        <General
                            serialNumber={component.serialNumber}
                            materialNumber={component.materialNumber}
                            date={component.productionDate}
                            manufacturerUrl={component.manufacturerUrl}
                            manufacturerName={component.manufacturerName}
                            isEditorView={isEditorView}
                        />
                        <AttributeComponent
                            keyValues={component.keyValue}
                            isEditorView={isEditorView} />
                        <DocumentComponent
                            files={component.document}
                            isEditorView={isEditorView} />
                        {!isEditorView && <QrCodeComponent componentQrCode={componentQrCode} />}

                    </div>
                    {!isEditorView && <Footer />}
                </div>
            </div>
        </div>
    )
}

export default WebView